module.exports = __webpack_public_path__ + "img/wecom-temp.fc205010.svg";